import { isPlatformBrowser } from '@angular/common';
import { Injectable, Inject, PLATFORM_ID, Optional } from '@angular/core';
import {
  OpenIdConfiguration,
  StsConfigStaticLoader,
} from 'angular-auth-oidc-client';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class OidcConfigService {
  constructor(
    @Inject(PLATFORM_ID)
    private platformId: Record<string, unknown>,
    @Optional() @Inject('X_FORWARDED_HOST') private host: string
  ) {}

  getConfig(): OpenIdConfiguration {
    const redirectUrl = isPlatformBrowser(this.platformId)
      ? window.location.origin + '/callback'
      : `${this.host}/callback`;
    const postLogoutRedirectUri = isPlatformBrowser(this.platformId)
      ? window.location.origin + '/agent'
      : `${this.host}/agent`;

    return {
      authority: `https://login.microsoftonline.com/${environment.tenantId}/v2.0`,
      redirectUrl,
      clientId:  environment.clientId,
      unauthorizedRoute: 'unauthorized',
      postLogoutRedirectUri,
      scope: environment.entraScope,
      responseType: 'code',
      silentRenew: true,
      useRefreshToken: true,
      maxIdTokenIatOffsetAllowedInSeconds: 600,
      issValidationOff: false,
      autoUserInfo: false,
      customParamsAuthRequest: {
        prompt: 'select_account', // login, consent
      },
    };
  }
}

export const authFactory = (configService: OidcConfigService) => {
  const config = configService.getConfig();
  return new StsConfigStaticLoader(config);
};
